import VK from './VK'

export default VK
// eslint-disable-next-line import/export
export * from './VK'
